/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-0" }]];
const IconPointFilled = createReactComponent("filled", "point-filled", "PointFilled", __iconNode);

export { __iconNode, IconPointFilled as default };
//# sourceMappingURL=IconPointFilled.mjs.map
